module.exports = __webpack_public_path__ + "static/media/Map.5d0c5491.png";